import PropTypes from 'prop-types';
import { path } from 'ramda';
import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';

import CardHeader from '@material-ui/core/CardHeader';
import Divider from '@material-ui/core/Divider';

import { connect } from 'react-redux';
import { createResource } from 'redux-json-api';
import { SubmissionError } from 'redux-form';

import { closeLeftBarModule, showSnackbarMessage } from '../../modules/actions/layout';
import BusForm from './Form';

class BusAdd extends Component {
  static propTypes = {
    apiEndpoint: PropTypes.string.isRequired,
    createResource: PropTypes.func.isRequired,
    closeLeftBarModule: PropTypes.func.isRequired,
    showSnackbarMessage: PropTypes.func.isRequired,
  };

  render() {
    const { apiEndpoint, createResource, closeLeftBarModule, showSnackbarMessage } = this.props;

    return (
      <Grid fluid>
        <Row>
          <Col style={{ margin: 20, width: '100%' }}>
            <CardHeader title="Bus toevoegen" />
            <Divider />
            <BusForm
              onSubmit={async (values) => {
                try {
                  const entity = {
                    type: 'vehicle',
                    attributes: {
                      'license-plate': values.license_plate,
                      'vehicle-number': values.vehicle_number,
                      'year-of-registration': values.year_of_registration,
                      'euronorm': values.euronorm,
                      'seats': values.seats,
                      'standing-places': values.standing_places,
                      'bikes-allowed': values.bikes_allowed || false,
                      'toilet-available': values.toilet_available || false,
                      'photo': values.photo,
                      'company': `${apiEndpoint}/company/${values.company}`,
                    },
                  };

                  await createResource(entity);
                  closeLeftBarModule('bus');
                  showSnackbarMessage('Bus toegevoegd');
                } catch (exc) {
                  let errors = {};
                  const res = await exc.response.json();

                  res.errors.forEach(e => {
                    const field = path(['source', 'pointer'], e)
                      .replace('/data/attributes/', '')
                      .replace('-', '_');

                    if (field === 'non_field_errors') errors._error = e.detail;
                    else {
                      errors[field] = e.detail;

                      switch (field) {
                        case 'license_plate': {
                          errors[field] += ' (voorbeeld: BP-NN-74)';
                          break;
                        }
                        case 'vehicle_number': {
                          errors[field] += ' (voorbeeld: 7153)';
                          break;
                        }
                        case 'year_of_registration': {
                          errors[field] += ' (voorbeeld: 2004)';
                          break;
                        }
                        case 'euronorm': {
                          errors[field] += ' (voorbeeld: Euro 3)';
                          break;
                        }
                        case 'seats': {
                          errors[field] += ' (voorbeeld: 42)';
                          break;
                        }
                        case 'standing_places': {
                          errors[field] += ' (voorbeeld: 12)';
                          break;
                        }
                        case 'company': {
                          errors[field] += ' (kies een bedrijf uit de lijst)';
                          break;
                        }
                      }
                    }
                  });

                  showSnackbarMessage('Er is iets fout gegaan bij het toevoegen van de bus.');

                  throw new SubmissionError(errors);
                }
              }}
            />
          </Col>
        </Row>
      </Grid>
    );
  };
};

const mapStateToProps = (state) => ({
  apiEndpoint: path(['api', 'endpoint', 'axiosConfig', 'baseURL'], state),
});

const mapDispatchToProps = {
  createResource,
  closeLeftBarModule,
  showSnackbarMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(BusAdd);
